import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { SettingsContextProvider } from "./context/SettingsContextProvider";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "normalize.css";
import "./index.css"

ReactDOM.render(
    <React.StrictMode>
        <SettingsContextProvider>
            <App />
        </SettingsContextProvider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
